export default "/assets/images/price-del.png?48100c08cf33e43d6d31f8b0fb2ebbca";